import {getField, updateField} from 'vuex-map-fields';

const state = {
    inventario: [],
    recienteslocal: [],
    links: [],
    filtroslocal: {
        marca: null,
        modelo: null,
        linea: null,
        ubicacion: null,
        combustible: null,
        caja: null,
        precio: []
    },
    marcas: [],
    lineas: [],
    modelos: [],
    versiones: [],
    contadoreslocal: {
        marcas: [],
        modelos: [],
        lineas: [],
        caja: [],
        combustible: []
    }
}

const getters = {
    getField,
}

const mutations = {
    updateField,
    setMarcas(state, payload) {
        state.marcas = payload;
    },
    setModelos(state, payload) {
        state.modelos = payload
    },
    setLineas(state, payload) {
        state.lineas = payload
    },
    setVersiones(state, payload) {
        state.versiones = payload
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations
}
